"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchMatches = exports.updateMatch = exports.updateBet = exports.unsubscribeFromUpdates = exports.subscribeToUpdates = void 0;
var entities_1 = __importDefault(require("../entities"));
var utils_1 = require("../utils");
var constants_1 = require("./constants");
var makeSearchMatchesFn = entities_1.default.actions.makeSearchMatchesFn;
var subscribeToUpdates = function (origin, method, variables, batch) { return ({
    type: constants_1.SUBSCRIBE_TO_UPDATES,
    payload: { origin: origin, subOpts: { method: method, variables: variables }, batch: batch },
}); };
exports.subscribeToUpdates = subscribeToUpdates;
var unsubscribeFromUpdates = function (origin, method, variables, batch) { return ({
    type: constants_1.UNSUBSCRIBE_TO_UPDATES,
    payload: { origin: origin, subOpts: { method: method, variables: variables }, batch: batch },
}); };
exports.unsubscribeFromUpdates = unsubscribeFromUpdates;
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
function updateBet(entities) {
    return utils_1.makeAction(constants_1.UPDATE_BET, { entities: entities });
}
exports.updateBet = updateBet;
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
function updateMatch(entities, origin, isTopMarkets) {
    return {
        type: constants_1.UPDATE_MATCH,
        payload: { entities: entities, opts: { origin: origin } },
        meta: { isTopMarkets: isTopMarkets },
    };
}
exports.updateMatch = updateMatch;
exports.searchMatches = makeSearchMatchesFn(constants_1.GET_MATCHES_REQUEST);
//# sourceMappingURL=actions.js.map